import { render, staticRenderFns } from "./TabComentario.vue?vue&type=template&id=716535a2&lang=html&"
import script from "./TabComentario.vue?vue&type=script&lang=js&"
export * from "./TabComentario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports